import React from "react";
import "./styles.css";
import { PageLayout } from "@BUP/components";
import { VideoHomeButton } from "./VideoHomeButton";
import { HomeButton } from "./HomeButton";
import ModoBupImage from "@BUP/assets/Images/Resources/modo_bup.png";
import { Row, Col } from "antd";
import { useAuth } from '@BUP/hooks';
import { isModeBup } from 'services/BraveUp';

const HomePage = () => {
  const { user } = useAuth();

  return (
    <PageLayout>
      <div className="home-page-container">
        <div className="content-wrapper">
          <h1 className="headline">¡Bienvenid@!</h1>
          <hr />
          <h2>
            Somos BRAVE UP! y esta plataforma será nuestro lugar de encuentro a
            lo largo del año. Aquí encontrarás todo lo necesario para que la
            convivencia escolar presencial y digital de tu comunidad mejore con
            la participación de todos y todas. Mientras, despierta tu curiosidad
            y anímate a descubrir las funciones y contenidos disponibles.
          </h2>
          <hr />
          <Row className="container-home-buttons" gutter={[50, 30]}>
            <Col xs={24} className="element-wrapper">
              <VideoHomeButton />
            </Col>
            <Col xs={24} md={isModeBup(user) ? 12 : 24} className="element-wrapper">
              <HomeButton
                linkTo="/resources"
                buttonText="DESCUBRE LOS RECURSOS"
              />
            </Col>
            {
              isModeBup(user) ?
                (
                  <Col xs={24} md={12} className="element-wrapper">
                    <HomeButton
                      linkTo="/modebup"
                      buttonText="ENVIAR MODO BUP"
                      img={ModoBupImage}
                    />
                  </Col>
                ) : null
            }
          </Row>
        </div>
      </div>
    </PageLayout>
  );
};

export default HomePage;
